var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field", class: { "has-addons": _vm.hasAddons } },
    [
      _vm.label && !_vm.hasAddons
        ? _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm.hasAddons
        ? _c("p", { staticClass: "control" }, [
            _c("a", { staticClass: "button is-static" }, [
              _vm._v(" " + _vm._s(_vm.label) + " "),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "control",
          class: { "is-clearfix": _vm.maxlength && _vm.hasCounter },
        },
        [
          _c("input", {
            staticClass: "input",
            class: [
              { "is-danger": _vm.showError },
              _vm.fieldSize,
              { "data-hj-whitelist": _vm.whitelist },
            ],
            attrs: {
              type: _vm.type,
              placeholder: _vm.placeholder,
              name: _vm.name,
              maxlength: _vm.maxlength,
              "data-test": _vm.name,
            },
            domProps: { value: _vm.value },
            on: { input: _vm.input, blur: _vm.blur, focus: _vm.focus },
          }),
          _vm.maxlength && _vm.hasCounter
            ? _c("small", { staticClass: "help counter" }, [
                _vm._v(_vm._s(_vm.valuelength) + " / " + _vm._s(_vm.maxlength)),
              ])
            : _vm._e(),
        ]
      ),
      _vm.showError
        ? _c(
            "p",
            {
              staticClass: "help is-danger",
              attrs: { "data-test": "error-" + _vm.name },
            },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }